import PageLayout from "@components/PageLayout";
import { httpsCallable } from "firebase/functions";
import { functions } from "lib/firebase";
import { Box } from "@chakra-ui/react";
import HeadingWithSubtitle from "@components/common/HeadingWithSubtitle";
import { PricingSection } from "@components/landing/PricingSection";

const Pricing = ({ plans }) => {
  return (
    <PageLayout>
      <Box textAlign="center" my={12}>
        <HeadingWithSubtitle
          title="Pricing"
          subtitle="Upgrade your Retro team to house more members."
        />
      </Box>

      <PricingSection plans={plans} />
    </PageLayout>
  );
};

export async function getStaticProps() {
  // Fetch plans from the API
  const getPlans = httpsCallable(functions, "core-getPlans");

  const res = await getPlans();
  const plans = res.data.data;

  return {
    props: {
      plans,
    }, // will be passed to the page component as props
  };
}

export default Pricing;
